import { render, staticRenderFns } from "./user-extension-select.vue?vue&type=template&id=30cd4548"
import script from "./user-extension-select.vue?vue&type=script&lang=js"
export * from "./user-extension-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports